export default {
    watch: {
        errors: {
            handler: function(errorBag) {
                if (this.errors.any()) {
                    let errors = Object.keys(errorBag.items).map(key => {
                        return errorBag.items[key].msg;
                    });
                    this.$store.dispatch('Flash/setFlash', { message: errors });
                } else {
                    this.$store.dispatch('Flash/clearFlash');
                }
            },
            deep: true
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/errors.js